const STATE_FULL = { FL: 'florida', AL: 'alabama', GA: 'georgia' };

const CITIES = [
  // Florida cities
  { slug: 'marianna', name: 'Marianna', state: 'FL', distance: 0, direction: '', pop: '7,000' },
  { slug: 'malone', name: 'Malone', state: 'FL', distance: 13, direction: 'north', pop: '2,000' },
  { slug: 'greenwood', name: 'Greenwood', state: 'FL', distance: 8, direction: 'west', pop: '700' },
  { slug: 'grand-ridge', name: 'Grand Ridge', state: 'FL', distance: 10, direction: 'east', pop: '900' },
  { slug: 'cottondale', name: 'Cottondale', state: 'FL', distance: 12, direction: 'southwest', pop: '950' },
  { slug: 'bascom', name: 'Bascom', state: 'FL', distance: 15, direction: 'north', pop: '100' },
  { slug: 'campbellton', name: 'Campbellton', state: 'FL', distance: 18, direction: 'northwest', pop: '200' },
  { slug: 'chipley', name: 'Chipley', state: 'FL', distance: 19, direction: 'west', pop: '3,600' },
  { slug: 'sneads', name: 'Sneads', state: 'FL', distance: 19, direction: 'east', pop: '1,900' },
  { slug: 'graceville', name: 'Graceville', state: 'FL', distance: 21, direction: 'northwest', pop: '2,300' },
  { slug: 'altha', name: 'Altha', state: 'FL', distance: 22, direction: 'south', pop: '500' },
  { slug: 'chattahoochee', name: 'Chattahoochee', state: 'FL', distance: 23, direction: 'east', pop: '3,200' },
  { slug: 'blountstown', name: 'Blountstown', state: 'FL', distance: 25, direction: 'southeast', pop: '2,500' },
  { slug: 'wausau', name: 'Wausau', state: 'FL', distance: 26, direction: 'west', pop: '400' },
  { slug: 'bonifay', name: 'Bonifay', state: 'FL', distance: 27, direction: 'west', pop: '2,800' },
  { slug: 'bristol', name: 'Bristol', state: 'FL', distance: 28, direction: 'southeast', pop: '1,000' },
  { slug: 'noma', name: 'Noma', state: 'FL', distance: 30, direction: 'northwest', pop: '200' },
  { slug: 'westville', name: 'Westville', state: 'FL', distance: 32, direction: 'west', pop: '300' },
  { slug: 'caryville', name: 'Caryville', state: 'FL', distance: 34, direction: 'west', pop: '200' },
  { slug: 'gretna', name: 'Gretna', state: 'FL', distance: 35, direction: 'east', pop: '1,700' },
  { slug: 'quincy', name: 'Quincy', state: 'FL', distance: 40, direction: 'east', pop: '7,200' },
  { slug: 'panama-city', name: 'Panama City', state: 'FL', distance: 48, direction: 'south', pop: '37,000' },
  { slug: 'lynn-haven', name: 'Lynn Haven', state: 'FL', distance: 45, direction: 'south', pop: '21,000' },
  { slug: 'bayou-george', name: 'Bayou George', state: 'FL', distance: 40, direction: 'south', pop: '7,500' },
  { slug: 'youngstown', name: 'Youngstown', state: 'FL', distance: 35, direction: 'south', pop: '2,500' },
  // Alabama cities
  { slug: 'cottonwood', name: 'Cottonwood', state: 'AL', distance: 20, direction: 'north', pop: '1,200' },
  { slug: 'rehobeth', name: 'Rehobeth', state: 'AL', distance: 28, direction: 'northwest', pop: '1,400' },
  { slug: 'ashford', name: 'Ashford', state: 'AL', distance: 28, direction: 'north', pop: '2,100' },
  { slug: 'cowarts', name: 'Cowarts', state: 'AL', distance: 30, direction: 'north', pop: '1,800' },
  { slug: 'slocomb', name: 'Slocomb', state: 'AL', distance: 32, direction: 'northwest', pop: '2,000' },
  { slug: 'dothan', name: 'Dothan', state: 'AL', distance: 33, direction: 'north', pop: '72,000' },
  { slug: 'taylor', name: 'Taylor', state: 'AL', distance: 31, direction: 'northwest', pop: '2,200' },
  { slug: 'malvern', name: 'Malvern', state: 'AL', distance: 31, direction: 'northwest', pop: '1,600' },
  { slug: 'webb', name: 'Webb', state: 'AL', distance: 34, direction: 'north', pop: '1,300' },
  { slug: 'hartford', name: 'Hartford', state: 'AL', distance: 36, direction: 'northwest', pop: '2,600' },
  { slug: 'kinsey', name: 'Kinsey', state: 'AL', distance: 37, direction: 'north', pop: '2,300' },
  { slug: 'headland', name: 'Headland', state: 'AL', distance: 40, direction: 'north', pop: '4,700' },
  { slug: 'gordon', name: 'Gordon', state: 'AL', distance: 38, direction: 'north', pop: '1,700' },
  { slug: 'columbia', name: 'Columbia', state: 'AL', distance: 42, direction: 'north', pop: '800' },
  { slug: 'abbeville', name: 'Abbeville', state: 'AL', distance: 45, direction: 'northeast', pop: '2,600' },
  // Georgia cities
  { slug: 'donalsonville', name: 'Donalsonville', state: 'GA', distance: 28, direction: 'northeast', pop: '2,800' },
  { slug: 'colquitt', name: 'Colquitt', state: 'GA', distance: 40, direction: 'northeast', pop: '1,900' },
  { slug: 'iron-city', name: 'Iron City', state: 'GA', distance: 32, direction: 'northeast', pop: '300' },
  { slug: 'jakin', name: 'Jakin', state: 'GA', distance: 25, direction: 'northeast', pop: '100' },
  { slug: 'bainbridge', name: 'Bainbridge', state: 'GA', distance: 45, direction: 'east', pop: '13,000' },
];

export function getCityUrl(city) {
  const stateSlug = STATE_FULL[city.state] || city.state.toLowerCase();
  return `/pawn-shop-${city.slug}-${stateSlug}.html`;
}

export function parseCityFromUrl(urlSlug) {
  // urlSlug comes in as "pawn-shop-dothan-al-alabama.html" etc, we strip prefix/suffix
  const clean = urlSlug.replace(/^pawn-shop-/, '').replace(/\.html$/, '');
  // Try matching against each city
  for (const city of CITIES) {
    const stateSlug = STATE_FULL[city.state] || city.state.toLowerCase();
    const expected = `${city.slug}-${stateSlug}`;
    if (clean === expected) return city;
  }
  return null;
}

export { STATE_FULL };
export default CITIES;
